var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookFooterFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 0.5H2.5L0.5 2.77401V33.5L2.5 35.5H17.5V23.5H12.5V17.5H17.5V15.5L18 11L20 8L24 6.5H30V12.5H24.5L23.5 13.5V17.5H29.5V23.5H23.5V35.5H34L35.5 33V2L33.5 0.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 0H3.00002C1.31998 0 0 1.31998 0 3.00002V33C0 34.68 1.31998 36 3.00002 36H16.8H24H33C34.68 36 36 34.68 36 33V3.00002C36 1.31998 34.68 0 33 0ZM18 34.8V22.8H13.2V18H18V13.8C18 10.38 20.64 7.50002 24 7.2H29.4V12H24.6C23.5799 12 22.8 12.78 22.8 13.8V18H28.8V22.8H22.8V34.8H18V34.8ZM34.8 33C34.8 34.02 34.02 34.8 33 34.8H24V24H30V16.8H24V13.8C24 13.44 24.24 13.2 24.6 13.2H30.6V5.99998H23.94C19.92 6.35998 16.8 9.77998 16.8 13.8V16.8H12V24H16.8V34.8H3.00002C1.98 34.8 1.20002 34.02 1.20002 33V3.00002C1.20002 1.98 1.98 1.20002 3.00002 1.20002H33C34.0201 1.20002 34.8 1.98 34.8 3.00002V33H34.8Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFooterFilled);
export default __webpack_public_path__ + "static/media/facebook-footer-filled.f228337e.svg";
export { ForwardRef as ReactComponent };